export type Viewer = 'owner' | 'write' | 'read';
export const VIEWER_IDS: Viewer[] = ['owner', 'write', 'read'];
export const VIEWERS = {
  owner: { name: 'Camille Martin', label: 'Propriétaire', group: 'Propriétaire du projet', reason: 'Camille Martin possède le projet ; gestion des accès hors de cette simulation.' },
  write: { name: 'Amélie Laurent', label: 'Écriture', group: 'Chargés d’études Plan', reason: 'Amélie Laurent appartient au groupe autorisé à modifier cette étude.' },
  read: { name: 'Julien Bernard', label: 'Lecture', group: 'Consultation Plan', reason: 'Julien Bernard appartient au groupe de consultation ; exports autorisés.' },
} as const;
export const isViewerId = (id: string | null): id is Viewer => id !== null && VIEWER_IDS.includes(id as Viewer);
export function viewerFromSearch(search: string): Viewer {
  const id = new URLSearchParams(search).get('as');
  return isViewerId(id) ? id : 'write';
}
/** Droits génériques de démonstration confirmés dans le brief, pas un RBAC backend Plan. */
export function computePermissions(viewer: Viewer) {
  const write = viewer === 'owner' || viewer === 'write';
  return { canRead: true, canWrite: write, canDelete: write, canManageAccess: viewer === 'owner', canEdit: write };
}
